import { ModuleFE_FHIRResourceParamValue } from './ModuleFE_FHIRResourceParamValue.js';
export const ModulePackFE_FHIRResourceParamValueDB = [ModuleFE_FHIRResourceParamValue];
//# sourceMappingURL=module-pack.js.map